module.exports = __webpack_public_path__ + "static/img/value1.6315f36.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mImg/value1.png
// module id = Cv07
// module chunks = 0